import { startOfYear, subYears } from "date-fns";
import { useLockDate } from "../api/lock.api";
import { useTransactionsQuery } from "../components/transactions/useTransactionsQuery";
import { FinancialAccount } from "../common/types/financialAccount";

export function useLockedTransactionsForFinancialAccount(
    account: FinancialAccount,
) {
    const lockDate = useLockDate(account.entityId);
    const {
        query: {
            data: lockedTransactionsData,
            isLoading: lockedTransactionsLoading,
        },
    } = useTransactionsQuery({
        filters: {
            accountIds: [account.id],
            entityIds: [account.entityId!],
            end: lockDate ?? subYears(startOfYear(new Date()), 10), // because we could not use hook conditionally - set end date in the far past in case if there is no lock date
        },
        page: 1,
        limit: 1, // we need only total that's why we set the lowest safe value
    });
    const lockedTransactionsCount = lockedTransactionsData?.total ?? 0;

    return {
        lockedTransactionsCount,
        lockedTransactionsLoading,
        hasLockedTransactions: lockedTransactionsCount > 0,
    };
}
